import { render, staticRenderFns } from "./FraudForce.vue?vue&type=template&id=e08a97e8"
import script from "./FraudForce.vue?vue&type=script&lang=ts"
export * from "./FraudForce.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports